import { render, staticRenderFns } from "./ChecklistDialogItemObs.vue?vue&type=template&id=0e4b8265"
import script from "./ChecklistDialogItemObs.vue?vue&type=script&lang=js"
export * from "./ChecklistDialogItemObs.vue?vue&type=script&lang=js"
import style0 from "./ChecklistDialogItemObs.vue?vue&type=style&index=0&id=0e4b8265&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports